import { Fab } from '@material-ui/core'
import AddShoppingCart from '@material-ui/icons/AddShoppingCart'
import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

const FloatingButton = styled(Fab)`
  position: fixed;
  bottom: 60%;
  right: 16px;
`

export const CartButton: React.FC = () => {
  const { location, push } = useHistory()

  if (!location.pathname.startsWith('/nav/biblioteca')) return null

  const handleClick = () => {
    const paths = location.pathname.split('/')
    const product = paths[paths.length - 1]

    push(`/nav/orcamento?produto=${product}`)
  }

  return (
    <FloatingButton color="primary" onClick={handleClick}>
      <AddShoppingCart />
    </FloatingButton>
  )
}
